<span #trigger [attr.data-placement]="placement">
  <ng-content select="[trigger]"></ng-content>
</span>

<div #infoToolTip class="hidden flex-container">
  <ng-content select="[content]"></ng-content>
</div>